import * as React from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { GoBackV2 } from '../../components/GoBack/GoBackV2';
import LabelDetail from '../../components/LabelDetail/LabelDetail';
import BorderBox from './components/BorderBox';

const OfferDetailSkeleton: React.FC = () => {
  return (
    <Box>
      <GoBackV2 title='Back' sx={{ mb: '20px' }} />

      <Box>
        <Skeleton variant='rounded' height={'265px'} width={'100%'} />
      </Box>

      <Stack spacing={2} sx={{ mt: 4 }}>
        <BorderBox title='Offer details'>
          {[...Array(7)].map((_, i) => (
            <LabelDetail
              key={i}
              label={<Skeleton width='80%' />}
              description={<Skeleton width='100%' />}
            />
          ))}
        </BorderBox>
        <BorderBox title='Requirements'>
          <Stack divider={<Divider />} spacing={2} sx={{ mt: 3 }}>
            <Skeleton />
            <Skeleton />
          </Stack>
        </BorderBox>
      </Stack>

      <Box display='flex' mt={2} justifyContent='space-between'>
        <Stack direction='row' width='75%' spacing={2}>
          <Skeleton variant='rounded' width='30%' height={40} />
          <Skeleton variant='rounded' width='70%' height={40} />
        </Stack>
      </Box>
    </Box>
  );
};

export default OfferDetailSkeleton;
